<div role="dialog" aria-labelledby="modalMediaPreview" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalMediaPreview">
          {{ 'shared.previewMedia.title' | translate }}
          <br>
          <span class="text-muted fw-normal font-14">{{ textDescription }}</span>
        </h4>
        <button type="button" class="btn-close" (click)="onCancel()" aria-hidden="true"></button>
      </div>
      <div class="modal-body custom-scroll-bar">
        @if (mode === 'view') {
          <div class="icon-chat" (click)="onCancel()">
              <mat-icon>clear</mat-icon>
          </div>
        }

        <div class="preview-container">
          @if(loadingSpinner$ | async) {
            <loading-component />
          }

          @if (!(loadingSpinner$ | async)) {
            <div class="bg-preview">
                @switch (data.type) {
                  @case ('image') {
                    <div class="rounded d-flex flex-column align-items-center justify-content-center mt-4 p-2">
                      <img 
                        class="rounded p-2" 
                        [src]="data.midia"
                        [alt]="'shared.previewMedia.previewAlt' | translate"
                      />

                      @if (data.midia && this.mode === 'edit' && !isEdit) {
                        <div class="w-100 d-flex gap-2 align-items-center justify-center mt-4 p-2 border rounded">
                          <strong class="w-75">
                            {{ data.message }}
                          </strong>
                          <i class="ri-edit-2-line" (click)="toggleEdit()">edit</i>
                        </div>
                      }

                      @if (data.midia && isEdit) {
                        <div class="w-100 d-flex gap-2 align-items-center justify-center mt-4 p-2 border rounded">
                            <input 
                              [(ngModel)]="data.message" 
                              class="form-control"
                            />
                            <i class="ri-delete-bin-5-line text-danger" (click)="toggleEdit()">clear</i>
                        </div>
                      }
                    </div>
                  }
                  @case ('video') {
                    <div class="rounded d-flex flex-column align-items-center justify-content-center mt-4 p-2">
                        <video controls [src]="data.midia"></video>
                        @if (data.midia && this.mode === 'edit' && !isEdit) {
                          <div class="w-full flex gap-2 items-center justify-center mt-[15px] p-2 border border-[#bdbdbd] rounded-lg">
                              <strong>{{ data.message }}</strong><mat-icon
                                  class="hover:bg-[#f2f2f3] hover:fill-white hover:rounded-full cursor-pointer w-[3rem]  text-black"
                                  (click)="toggleEdit()">edit</mat-icon>
                          </div>
                        }
                        @if (data.midia && isEdit) {
                        <div class="w-full flex gap-2 items-center justify-center mt-[15px] p-2">
                            <input type="text" [(ngModel)]="data.message" class="input-field">
                            <mat-icon class="hover:bg-[#f2f2f3] hover:fill-white hover:rounded-full text-red-500 cursor-pointer"
                                (click)="toggleEdit()">clear</mat-icon>
                        </div>
                        }
                    </div>
                  }
                  @case ('audio') {
                    <div class="rounded d-flex flex-column align-items-center justify-content-center mt-4 p-2">
                        <audio controls [src]="data.midia"></audio>
                        @if (data.midia && this.mode === 'edit' && !isEdit) {
                        <div class="w-full flex gap-2 items-center justify-center mt-[15px] p-2 border border-[#bdbdbd] rounded-lg">
                            <strong>{{ data.message }}</strong><mat-icon
                                class="hover:bg-[#f2f2f3] hover:fill-white hover:rounded-full cursor-pointer w-[3rem] text-black"
                                (click)="toggleEdit()">edit</mat-icon>
                        </div>
                        }
                        @if (data.midia && isEdit) {
                        <div class="w-full flex gap-2 items-center justify-center mt-[15px] p-2 max-w-96">
                            <input type="text" [(ngModel)]="data.message" class="input-field">
                            <mat-icon class="hover:bg-[#f2f2f3] hover:fill-white hover:rounded-full text-red-500 cursor-pointer"
                                (click)="toggleEdit()">clear</mat-icon>
                        </div>
                        }
                    </div>
                  }
                  @case ('document') {
                    <div class="card mt-2 mb-1 shadow-none border text-start">
                      <div class="p-2">
                          <div class="row align-items-center">
                              <div class="col-auto">
                                  <div class="avatar-sm">
                                      <span class="avatar-title rounded">
                                        .{{ data.response?.contentType?.split('/').pop() || data.filename?.split('.').pop() || '' }}
                                      </span>
                                  </div>
                              </div>
                              <div class="col ps-0">
                                <a [href]="data.midia" target="_blank" rel="noopener noreferrer" class="text-muted fw-bold" download>
                                  {{ 'shared.previewMedia.download' | translate }} {{ data.filename ?? getFileNameFromUrl(data.midia) | truncate: 30 }}
                                </a>
                              </div>
                              <div class="col-auto">
                                <a [href]="data.midia" target="_blank" rel="noopener noreferrer" class="btn btn-link btn-lg text-muted" download>
                                  <i class="ri-download-2-line"></i>
                                </a>
                              </div>
                          </div>
                      </div>
                  </div>
                  
                    <!-- <div class="rounded d-flex flex-column align-items-center justify-content-center mt-4 p-2">
                        <a class="flex items-center justify-center gap-2" [href]="data.midia" target="_blank" download>Download {{ data.filename ??
                            getFileNameFromUrl(data.midia) | truncate: 100
                            }} <mat-icon>file_download</mat-icon></a>
                        @if (data.midia && this.mode === 'edit' && !isEdit) {
                        <div class="w-full flex gap-2 items-center justify-center mt-[15px] p-2 border border-[#bdbdbd] rounded-lg">
                            <strong>{{ data.message }}</strong> <mat-icon
                                class="hover:bg-[#f2f2f3] hover:fill-white hover:rounded-full cursor-pointer w-[3rem]  text-black"
                                (click)="toggleEdit()">edit</mat-icon>
                        </div>
                        }
                        @if (data.midia && isEdit) {
                        <div class="w-full flex gap-2 items-center justify-center mt-[15px] p-2">
                            <input type="text" [(ngModel)]="data.message" class="input-field">
                            <mat-icon class="hover:bg-[#f2f2f3] hover:fill-white hover:rounded-full text-red-500 cursor-pointer"
                                (click)="toggleEdit()">clear</mat-icon>
                        </div>
                        }
                    </div> -->
                  }
                }
            </div>
          }
      </div>
      </div>
      <div class="modal-footer">
        @if (!(loadingSpinner$ | async) && mode !== 'view') {
          @if(data.type !== 'audio' && this.mode !== 'edit') {
            <input 
              class="form-control mt-4 mb-2" 
              [(ngModel)]="data.message" 
              type="text" 
              name="message" 
              [placeholder]="'shared.previewMedia.captionPlaceholder' | translate: { type: translateType(data.type) }"
            />    
          }

          <button
            (click)="onCancel()"
            class="btn btn-light"
          >
            {{ 'shared.previewMedia.cancel' | translate }}
          </button>
          <button
            (click)="onSend()"
            class="btn btn-primary"
          >
            {{ 'shared.previewMedia.send' | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</div>

